import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import xeroLogo from '../../assets/images/xero-logo.png';
import myobLogo from '../../assets/images/myob-logo.png';
import quickbooksLogo from '../../assets/images/quickbooks-icon.jpg';
import reckonLogo from '../../assets/images/reckon-logo.jpg';
import sageLogo from '../../assets/images/sage-logo.jpg';
import contactUsLogo from '../../assets/images/contact-us-logo.webp';
import './index.css';

const Question = () => {
  return <p className="text-start fs-5">What accounting software do you currently use for your business?</p>;
};

const CustomModal = ({ show, onClose, selectedSoftware, handleLogin }) => {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <button className="close-btn" onClick={onClose}>&times;</button>
        <h4>{selectedSoftware?.name} Login</h4>
        {selectedSoftware && (
          <>
            <img
              src={selectedSoftware.img}
              alt={selectedSoftware.name}
              style={{ width: "80px", height: "80px", marginBottom: "10px" }}
            />
            <form onSubmit={handleLogin}>
              <input type="email" placeholder="Email" className="form-control mb-2" required />
              <input type="password" placeholder="Password" className="form-control mb-3" required />
              <button type="submit" className="btn btn-success w-100">Login</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

const Options = ({ softwareList, handleShow }) => (
  <div className="d-flex flex-wrap gap-3 my-3">
    {softwareList.map((software) => (
      <div key={software.name} className="software-card">
        <img src={software.img} alt={software.name} className="software-logo" />
        <div className="software-name">{software.name}</div>
        <button className="btn btn-primary w-100" onClick={() => handleShow(software)}>
          Connect with {software.name}
        </button>
      </div>
    ))}
      <div key={"Contact Us"} className="software-card">
        <img src={contactUsLogo} alt={"Contact Us"} className="software-logo" />
        <div className="software-name">{"Contact Us"}</div>
        <button className="btn btn-primary w-100" onClick={() => handleShow(software)}>
        Contact Us
        </button>
      </div>
  </div>
);

const EntityDropdown = ({ entities, selectedEntity, handleEntityChange }) => {
  // const navigate = useNavigate();
  // if (selectedEntity) {
  //   navigate(`/${selectedEntity}`);
  //   localStorage.setItem("dashboardName", JSON.stringify(selectedEntity) );
  // }
  // const onEntityChange = (event) => {
  //   const selectedEntity = event.target.value;
  //   handleEntityChange(selectedEntity);
  //   if (selectedEntity) {
  //     navigate(`/login?dashboard=${selectedEntity}`);
  //   }
  // };
  return (
    <div className="mt-4">
      <label className="form-label">Select Your Entity</label>
      <select className="form-select" value={selectedEntity} onChange={handleEntityChange}>
        <option value="">-- Select an Entity --</option>
        {entities.map((entity, index) => (
          <option key={index} value={entity}>
            {entity}
          </option>
        ))}
      </select>
    </div>
  );
};
 

const Step2 = () => {
  const [selectedSoftware, setSelectedSoftware] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState("");

  const softwareList = [
    { name: "Xero", link: "https://login.xero.com/identity/user/login", img: xeroLogo },
    { name: "MYOB", link: "https://www.myob.com/", img: myobLogo },
    { name: "QuickBooks", link: "https://accounts.intuit.com/app/sign-in", img: quickbooksLogo },
    { name: "Reckon", link: "https://accounts.intuit.com/app/sign-in", img: reckonLogo },
    { name: "Sage", link: "https://accounts.intuit.com/app/sign-in", img: sageLogo },
  ];
  const entityList = ["motor-bikes-for-sale", "cables-r-us", "mens-Fashionware", "  The Pre-cast Concrete Company"];

  const handleShow = (software) => {
    setSelectedSoftware(software);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleLogin = (event) => {
    event.preventDefault();
    setIsLoggedIn(true);
    setShowModal(false);
  };

  const handleEntityChange = (e) => {
    setSelectedEntity(e.target.value);
    //console.log(e.target.value)
    localStorage.setItem('dashboardName', e.target.value);
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      <div className="container p-5 step2-container">
        <Question />
        <Options softwareList={softwareList} handleShow={handleShow} />
        <CustomModal show={showModal} onClose={handleClose} selectedSoftware={selectedSoftware} handleLogin={handleLogin} />

        {isLoggedIn ?  <EntityDropdown entities={entityList} selectedEntity={selectedEntity} handleEntityChange={handleEntityChange} /> : null}
         </div>
    </div>
  );
};

export default Step2;
